import { MachineData } from './Machine';
import { MachineAttribute } from './MachineAttribute';
import { MachineDataSource } from './MachineDataSource';
import { TUnconfirmedMachineAttributesMap } from './TUnconfirmedMachineAttributesMap';

const unconfirmedSources: MachineDataSource[] = [
    MachineDataSource.vin,
    MachineDataSource.model_metadata,
    MachineDataSource.reap,
];

export const getUnconfirmedMachineAttributesMap = (
    keySources: MachineData['KEY_SOURCES'],
): TUnconfirmedMachineAttributesMap => {
    const sources = keySources ?? {};
    const map: TUnconfirmedMachineAttributesMap = {};

    Object.keys(sources).forEach(attribute => {
        // biome-ignore lint/style/noNonNullAssertion: legacy
        const source = sources[attribute]!;

        if (unconfirmedSources.includes(source)) {
            map[attribute as MachineAttribute] = true;
        }
    });

    return map;
};
